import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";

export const getStudentEvents = async (studentId) => {
  const res = await axios.middleware(
    "/Backend.asmx/BK_AgendaEventosSincronosAluno",
    {
      params: {
        alunoid: studentId,
        timezone: -new Date().getTimezoneOffset() / 60,
      },
    }
  );
  return res[0].data;
};

export const useStudentEvents = ({ config, studentId } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["studentEvents", { studentId }],
    queryFn: () => getStudentEvents(studentId),
  });
};
